const normalizeAdjust = (photoAdjust) => {
  const x = Number(photoAdjust?.x);
  const y = Number(photoAdjust?.y);
  const zoom = Number(photoAdjust?.zoom);
  const rotation = Number(photoAdjust?.rotation);

  return {
    x: Number.isFinite(x) ? x : 0,
    y: Number.isFinite(y) ? y : 0,
    zoom: Number.isFinite(zoom) ? zoom : 1,
    rotation: Number.isFinite(rotation) ? rotation : 0
  };
};

export const buildPhotoAdjustTransform = (photoAdjust) => {
  const a = normalizeAdjust(photoAdjust);
  return `translate(-50%, -50%) rotate(${a.rotation}deg) translate(${a.x}%, ${a.y}%) scale(${a.zoom})`;
};

export const buildAdjustedImgStyle = (photoAdjust, fit = 'cover') => {
  const a = normalizeAdjust(photoAdjust);
  const hasAdjust = a.x !== 0 || a.y !== 0 || a.zoom !== 1 || a.rotation !== 0;
  if (!hasAdjust) return undefined;
  return {
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: '100%',
    height: '100%',
    objectFit: fit === 'contain' ? 'contain' : 'cover',
    transformOrigin: 'center center',
    transform: buildPhotoAdjustTransform(a)
  };
};

